import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=6c42f46a&scoped=true&"
import script from "./FileInput.vue?vue&type=script&lang=ts&"
export * from "./FileInput.vue?vue&type=script&lang=ts&"
import style0 from "./FileInput.vue?vue&type=style&index=0&id=6c42f46a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42f46a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
